import { ScreenshotNotFocusedError } from "models/screenshot";

import { captureToBlob } from "components/screenshot/utils/captureElementToClipboard";

export async function copyDashboardToClipboard(): Promise<Blob> {
  if (!document.hasFocus()) {
    throw new ScreenshotNotFocusedError(
      "Browser tab must be focused to capture screenshot"
    );
  }

  const element = document.querySelector(".ComponentPane") as HTMLElement;
  if (!element) throw new Error("Dashboard container not found");

  // Dismiss Mapbox popups/tooltips before capture
  document.querySelectorAll(".mapboxgl-popup").forEach((el) => el.remove());

  const blob = await captureToBlob(element);
  if (!blob) throw new Error("Failed to generate screenshot");

  await navigator.clipboard.write([new ClipboardItem({ "image/png": blob })]);

  return blob;
}
